import { api } from "../client";

export const postComplianceOverride = (body) => {
  return api.post(`/ComplianceOverride/multiple`, body);
};
